
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/guidebooks/[guidebookId]",
      function () {
        return require("private-next-pages/resources/guidebooks/[guidebookId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/guidebooks/[guidebookId]"])
      });
    }
  